import React from 'react';
import { SH2 } from './styles';

const H2 = ({
    children,
    titleUnderline,
}) => {
    return (
        <SH2 titleUnderline={titleUnderline} >
            { children }
        </SH2>
    );
};

export default H2;
